import { motion } from "framer-motion";

export const CircleThinking = (): JSX.Element => {
  return (
    <motion.div
      animate={{ scale: [1, 1.1, 1] }}
      className="w-4 h-4 bg-primary rounded-full"
      transition={{
        duration: 2,
        repeat: Infinity,
        ease: "easeInOut",
      }}
    />
  );
};
